import { render } from "./Fishing.vue?vue&type=template&id=4ff0f24e&scoped=true&ts=true"
import script from "./Fishing.vue?vue&type=script&lang=ts"
export * from "./Fishing.vue?vue&type=script&lang=ts"

import "./Fishing.vue?vue&type=style&index=0&id=4ff0f24e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff0f24e"]])

export default __exports__